export const AUDIT_DETAIL_TITLE = "Detalhes da Auditoria";
export const AUDIT_DETAIL_LOADING_MESSAGE = "Carregando os detalhes da auditoria...";
export const AUDIT_DETAIL_RETRY_LABEL = "Tentar novamente";
export const AUDIT_DETAIL_REAUTH_LABEL = "Entrar novamente";

/** Campo obrigatório que o serviço devolveu vazio, no padrão da tela de Usuários. */
export const AUDIT_DETAIL_EMPTY_FIELD = "—";

/** Rótulo do registro afetado quando o serviço não diz o tipo (usuário, perfil...). */
export const AUDIT_DETAIL_REGISTRO_FALLBACK_LABEL = "Registro Alterado";
